import React, { Component, PropTypes } from 'react';
import deepEqual from 'deep-equal';
import forEach from 'lodash/forEach';
import map from 'lodash/map';

import Spinner from '../../svg/spinner';
import InputCheckbox from '../input/checkbox';

import css from './multiselect.scss';

import {
	STATE_ALL_ON,
	STATE_ALL_OFF,
	STATE_UNDETERMINED,
} from '../../../constants/states';

export default class MultiSelect extends Component {
	static propTypes = {
		options: PropTypes.array,
		defaultFilterState: PropTypes.shape({}),
		placeholder: PropTypes.string,
		className: PropTypes.string,
		defaultState: PropTypes.bool,
		allowToggleAll: PropTypes.bool,
		onChange: PropTypes.func,
		showSpinner: PropTypes.bool,
	};

	static defaultProps = {
		options: [],
		placeholder: 'multiselect...',
		className: '',
		defaultState: false,
		allowToggleAll: true,
		onChange: () => {},
		showSpinner: true,
	};

	constructor(props) {
		super(props);

		this.state = {
			isActive: false,
			groupShow: this.constructGroups(props.options),
			groupState: this.constructGroups(props.options),
			options: props.options,
			showMoreGroups: false,
		};

		this.state.value = this.constructOptions(props.options, this.state),
		this.state.internalOptions = this.constructOptions(props.options, this.state);
		this.state.status = this.getCurrentStatus(this.state);
	}

	constructGroups(options) {
		let groups = {};

		options.map((item, i) => {
			groups[item.name] = (i > 1);
		});

		return groups;
	}

	componentWillReceiveProps(nProps) {
		// if options changed we update the internal representation - and discard any old selection
		if (!deepEqual(nProps.options, this.props.options)) {
			const newState = {
				...this.state,
				options: nProps.options,
				groupShow: this.constructGroups(nProps.options),
				groupState: this.constructGroups(nProps.options),
			};

			newState.internalOptions = this.constructOptions(nProps.options, newState);

			const { defaultFilterState } = nProps;
			if (defaultFilterState) {
				forEach(newState.internalOptions, (filter, filterName) => {
					if (newState.internalOptions[filterName]) {
						forEach(newState.internalOptions[filterName], (value, key) => {
							if (defaultFilterState[filterName] && typeof defaultFilterState[filterName][key] !== 'undefined') {
								newState.internalOptions[filterName][key] = defaultFilterState[filterName][key];
								if (defaultFilterState[filterName][key]) {
									newState.showMoreGroups = true;
								}
							}
						});
					}
				});
			}

			this.setState(newState);
		}
	}

	componentWillMount() {}

	componentDidUpdate() {}

	render() {
		let className = 'multiselect';
		let dropdownClass = 'multiselect__options';

		if (this.props.className) {
			className += ' ' + this.props.className;
		}

		if (this.props.allowToggleAll) {
			className += ' multiselect--toggleall';
		}

		if (this.state.isActive) {
			className += ' multiselect--active';
			dropdownClass += ' multiselect__options--active';
		}

		if (this.props.dropdownClass) {
			dropdownClass += ' ' + this.props.dropdownClass;
		}

		return (
			<div className={className}>
				{this.renderSelected()}
				{this.state.isActive && (
					<div className='multiselect__closer' onClick={this.close.bind(this)}></div>
				)}
				<div className={dropdownClass}>
						{this.props.showSpinner && (
							<Spinner className='multiselect__spinner' />
						)}

						{this.state.options.map(this.renderOption.bind(this))}
				</div>
			</div>
		);
	}

	renderSelected() {
		return (
			<div className='multiselect__activator' onClick={() => { this.toggleDropdown(); }}>
				{this.state.label || this.props.placeholder}
			</div>
		);
	}

	renderOption(opt, i) {
		let className = 'multiselect__option';
		const isCollection = (opt.value && typeof opt.value.map === 'function');
		const _options = this.state.internalOptions;

		if (opt.disabled) {
			className += ' multiselect__option--disabled';
		}

		if (opt.reset) {
			className += ' multiselect__option--reset';
		}

		if (
			(
				typeof _options[opt.name] !== 'undefined' &&
				typeof _options[opt.name][opt.value] !== 'undefined' &&
				_options[opt.name][opt.value]
			) || (
				opt.reset &&
				this.state.status === STATE_ALL_ON
			)
		) {
			className += ' multiselect__option--selected';
		}

		if (isCollection) {
			// console.log(opt);

			let groupClass = `multiselect__group multiselect__group${i}`;
			let groupHeadClass = 'multiselect__group__head';

			if (this.state.groupShow[opt.name]) {
				groupClass += ' multiselect__group--active';
				groupHeadClass += ' multiselect__group__head--selected';
			}

			if (this.state.showMoreGroups) {
				groupClass += ' multiselect__group--showmore';
			}

			return (
				<div key={i} className={groupClass}>
					<div className={groupHeadClass} onClick={() => this.toggleGroupCollapse(opt)}>
						<InputCheckbox name='toggleGroup' className='multiselect__group__head__checkbox' onChange={(val) => this.toggleGroupItems(val, opt)} value={this.state.groupState[opt.name]} />
						{opt.label}
					</div>
					<div className='multiselect__group__items'>
						{opt.value.map(this.renderOption.bind(this))}
					</div>
				</div>
			);
		}

		return (
			<div key={i} className={className} onClick={() => { !opt.disabled && this.selectOption(opt); }}>
				{opt.label}
			</div>
		);
	}

	toggleGroupItems(val, opt) {
		if (this.state.internalOptions[opt.name]) {
			const intOptions = {
				...this.state.internalOptions,
			};
			const keys = Object.keys(intOptions[opt.name]);

			for (let i = 0; i < keys.length; i++) {
				intOptions[opt.name][keys[i]] = !!val;
			}
			let newState = {
				...this.state,
				internalOptions: intOptions,
			};

			newState.showMoreGroups = this.getShowMoreStatus(newState);
			newState.internalOptions = this.fixCaseTypeStates(newState);
			newState.groupState = this.getGroupStatus(newState);

			this.setState(newState);
			this.onChange();
		}
	}

	toggleGroupCollapse(opt) {
		const newState = {
			...this.state,
			groupShow: {
				...this.state.groupShow,
			},
		};

		newState.groupShow[opt.name] = !newState.groupShow[opt.name];

		this.setState(newState);
	}

	constructOptions(options, state) {
		if (typeof options.reduce === 'function' && options.length) {
			const processItem = (item, oldResult) => {
				const newResult = {
					...oldResult,
				};

				if (item.label) {
					if (item.value && typeof item.value.reduce === 'function') { // value is array
						newResult[item.name] = {
							...this.constructOptions(item.value, state),
						};
					} else {
						newResult[item.value] = (typeof state.groupShow[item.name] !== 'undefined') ? state.groupShow[item.name] : this.props.defaultState;
					}
				}

				return newResult;
			};

			const structuredOptions = options.reduce((previousResult, currentItem, currentIndex, init) => {
				let result;

				if (currentIndex === 1) {
					result = processItem(previousResult, result);
				} else {
					result = previousResult;
				}

				result = processItem(currentItem, result);

				// console.log(result);
				return result;
			});

			return structuredOptions;
		}

		// console.log({});
		return {};
	}

	addToggleAll(props) {
		if (props.allowToggleAll) {
			return [
				{
					reset: true,
					label: 'Show Everything',
					value: 'toggleAll',
				},
				...props.options,
			];
		}

		return [
			...props.options,
		];
	}

	close() {
		this.state.isActive = false;
		this.setState(this.state);
	}

	toggleDropdown() {
		this.state.isActive = !this.state.isActive;
		this.setState(this.state);
	}

	selectOption(opt) {
		if (opt.reset) {
			this.toggleAllOptions();
		} else {
			//select normally
			this.toggleValue(opt.name, opt.value);
		}

		//this.close();
	}

	toggleAllOptions() {
		let setTo = null;

		switch (this.state.status) {
			case STATE_ALL_ON:
				setTo = false;
				//return false;
				this.state.status = STATE_ALL_OFF;
				break;
			case STATE_ALL_OFF:
			case STATE_UNDETERMINED:
				setTo = true;
				this.state.status = STATE_ALL_ON;
				break;
			default:
				setTo = this.props.defaultState;
				this.state.status = this.props.defaultState ? STATE_ALL_ON : STATE_ALL_OFF;
		}

		const keys = Object.keys(this.state.internalOptions);
		const newState = {
			...this.state,
			internalOptions: {
				...this.state.internalOptions,
			}
		};
		for (let i = 0; i < keys.length; i++) {
			let newKey = Object.keys(newState.internalOptions[keys[i]]);
			for (let k = 0; k < newKey.length; k++) {
				newState.internalOptions[keys[i]][newKey[k]] = setTo;
			}
		}

		this.setState(newState);
		this.onChange();

		//console.log(this.state.internalOptions);
		//console.log(JSON.stringify({...this.state.internalOptions}));
	}

	getCurrentStatus(state) {
		let keys = Object.keys(state.internalOptions);
		let prevVal;
		for (let i = 0; i < keys.length; i++) {
			let newKey = Object.keys(state.internalOptions[keys[i]]);
			for (let k = 0; k < newKey.length; k++) {
				if (prevVal !== undefined && prevVal !== state.internalOptions[keys[i]][newKey[k]]) {
					return STATE_UNDETERMINED;
				}

				prevVal = state.internalOptions[keys[i]][newKey[k]];
			}
		}

		return prevVal ? STATE_ALL_ON : STATE_ALL_OFF;
	}

	toggleValue(groupName, value) {
		if (
			groupName &&
			value &&
			typeof this.state.internalOptions[groupName] !== 'undefined' &&
			typeof this.state.internalOptions[groupName][value]  !== 'undefined'
		) {

			let newState = {
				...this.state,
				internalOptions: {
					...this.state.internalOptions
				},
			};

			if (value === 'top100') {
				forEach(this.state.internalOptions[groupName], (groupItemValue, groupItemKey) => {
					if (groupItemKey !== 'top100') {
						newState.internalOptions[groupName][groupItemKey] = false;
					}
				});
			}

			newState.internalOptions[groupName][value] = !this.state.internalOptions[groupName][value];

			// console.log(`options[${groupName}][${value}] = ${this.state.internalOptions[groupName][value]}`);

			// check toggle all status
			newState.status = this.getCurrentStatus(newState);

			newState.showMoreGroups = this.getShowMoreStatus(newState);
			newState.internalOptions = this.fixCaseTypeStates(newState);

			// check group status
			newState.groupState = this.getGroupStatus(newState);

			this.setState(newState);
			this.onChange();

			return true;
		}

		return false;
	}

	fixCaseTypeStates(state) {
		const internalOptions = {
			...state.internalOptions,
		};

		if (this.state.showMoreGroups !== state.showMoreGroups) {
			const groupName = 'caseTypes';
			const keys = Object.keys(internalOptions[groupName]);

			for (let i = 0; i < keys.length; i++) {
				// console.log(groupName, keys[i]);
				internalOptions[groupName][keys[i]] = true;
			}
		}

		return internalOptions;
	}

	getShowMoreStatus(state) {
		const groupName = 'awards';
		let STATUS = false;
		if (state.internalOptions[groupName]) {
			const keys = Object.keys(state.internalOptions[groupName]);

			for (let i = 0; i < keys.length; i++) {
				if (state.internalOptions[groupName][keys[i]]) {
					// if any awards are checked.. show more == true
					STATUS = true;
				}
			}
		}

		return STATUS;
	}

	getGroupStatus(state) {
		const groupState = {
			...state.groupState,
		};

		const groups = Object.keys(state.internalOptions);
		for (let k = 0; k < groups.length; k++) {
			let groupName = groups[k];
			let STATUS = true;

			if (state.internalOptions[groupName]) {
				const keys = Object.keys(state.internalOptions[groupName]);

				for (let i = 0; i < keys.length; i++) {
					if (!state.internalOptions[groupName][keys[i]]) {
						STATUS = false;
					}
				}
			}

			groupState[groupName] = STATUS;
		}

		// console.log(groupState);

		return groupState;
	}

	onChange() {
		if (typeof this.props.onChange === 'function') {
			return this.props.onChange(this.value());
		}
	}

	value() {
		// deepClone using JSON stringify->parse
		let clone = JSON.parse(JSON.stringify(this.state.internalOptions));
		return clone;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/form/select/multiselect.js
 **/